import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { mapStore } from "@/stores/map.svelte";

var $$_import_mapStore = $.reactive_import(() => mapStore);
var root = $.from_html(`<div class="map-controls svelte-s7wzpa50677n"><label class="section-label svelte-s7wzpa50677n">Map</label> <div class="controls-row svelte-s7wzpa50677n"><div class="control-group svelte-s7wzpa50677n"><span class="control-label svelte-s7wzpa50677n">Zoom</span> <div class="btn-group svelte-s7wzpa50677n"><button class="ctrl-btn svelte-s7wzpa50677n">−</button> <span class="ctrl-value svelte-s7wzpa50677n"> </span> <button class="ctrl-btn svelte-s7wzpa50677n">+</button></div></div> <div class="control-group svelte-s7wzpa50677n"><span class="control-label svelte-s7wzpa50677n">Plane</span> <div class="btn-group svelte-s7wzpa50677n"><button class="ctrl-btn svelte-s7wzpa50677n">▼</button> <span class="ctrl-value svelte-s7wzpa50677n"> </span> <button class="ctrl-btn svelte-s7wzpa50677n">▲</button></div></div></div> <label class="toggle-row svelte-s7wzpa50677n"><input type="checkbox" class="svelte-s7wzpa50677n"/> <span class="toggle-text svelte-s7wzpa50677n">Show coordinates</span></label></div>`);

function MapControls($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root();
	var div_1 = $.sibling($.child(div), 2);
	var div_2 = $.child(div_1);
	var div_3 = $.sibling($.child(div_2), 2);
	var button = $.child(div_3);
	var span = $.sibling(button, 2);
	var text = $.child(span, true);

	$.reset(span);

	var button_1 = $.sibling(span, 2);

	$.reset(div_3);
	$.reset(div_2);

	var div_4 = $.sibling(div_2, 2);
	var div_5 = $.sibling($.child(div_4), 2);
	var button_2 = $.child(div_5);
	var span_1 = $.sibling(button_2, 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);

	var button_3 = $.sibling(span_1, 2);

	$.reset(div_5);
	$.reset(div_4);
	$.reset(div_1);

	var label = $.sibling(div_1, 2);
	var input = $.child(label);

	$.remove_input_defaults(input);
	$.next(2);
	$.reset(label);
	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, $$_import_mapStore().zoom);
		button_2.disabled = $$_import_mapStore().plane <= 0;
		$.set_text(text_1, $$_import_mapStore().plane);
		button_3.disabled = $$_import_mapStore().plane >= 3;
		$.set_checked(input, $$_import_mapStore().showCoords);
	});

	$.delegated('click', button, () => $$_import_mapStore().zoomOut());
	$.delegated('click', button_1, () => $$_import_mapStore().zoomIn());
	$.delegated('click', button_2, () => $$_import_mapStore().planeDown());
	$.delegated('click', button_3, () => $$_import_mapStore().planeUp());
	$.delegated('change', input, () => $$_import_mapStore($$_import_mapStore().showCoords = !$$_import_mapStore().showCoords));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	MapControls = $.hmr(MapControls);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-s7wzpa50677n');
		MapControls[$.HMR].update(module.default);
	});
}

export default MapControls;

$.delegate(['click', 'change']);
import "bun-svelte:MapControls.svelte-112qn94s4jitm-style.css";